import Vue from 'vue';
import Toaster from 'v-toaster';
import Vue2Crumbs from 'vue-2-crumbs';
import VueTheMask from 'vue-the-mask';
import VTooltip from 'v-tooltip';
import Clipboard from 'v-clipboard';
import Toasted from 'vue-toasted';
import VueLazyload from 'vue-lazyload'

import 'moment/locale/uk'
import 'moment/locale/ru'


//use
Vue.use(VTooltip);
Vue.use(Vue2Crumbs);
Vue.use(Toasted);
Vue.use(Toaster, {
    timeout: 5000
});
Vue.use(VueTheMask);
Vue.use(Clipboard);
Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
})
